export class AuthModal {
  constructor(
   public email: string,
   public userID: number,
   public _token: string,
   public _retoken: string,
   public user_name?: string,
   public provider_id?: number,
   public provider_name?: string,
   public role?: string,
   public provider_user_id?: number,
  ) {}
}
export interface AuthCredential {
  email: string;
  password: string;
  portal: string;
}
export interface AuthOTPCredential {
  email: string;
  otp: string;
}
